import AlertBannerWrapper from "../components/AlertBannerWrapper/AlertBannerWrapper";
import AlertCloseButton from "../components/AlertCloseButton/AlertCloseButton";
import AlertMessage from "../components/AlertMessage/AlertMessage";
const AlertBannerInfo = ({ visible, children, onClick, visibleButton }) => {
  return (
    <AlertBannerWrapper backgroundColor={"#3cb371"} visible={visible}>
      <AlertMessage>{children}</AlertMessage>
      <AlertCloseButton
        onClick={onClick}
        iconStyle={{
          fill: "#3cb371",
          stroke: "#3cb371",
        }}
        visibleButton={visibleButton}
      ></AlertCloseButton>
    </AlertBannerWrapper>
  );
};

AlertBannerInfo.defaultProps = {
  visible: true,
  onClick: () => {},
};

export default AlertBannerInfo;
